import React from 'react';
import { FaTrashAlt, FaPenSquare } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import useBillers from '../hooks/useBillers';
import {
  TableWrapper,
  Table,
  TableHeader,
  TableRow,
  TableData,
  EditButton,
  DeleteButton,
} from '../styles/ComponentStyles';
import apiService from '../services/apiService'; // Centralized API service
import PaginationControl from './PaginationControl';

const BillersTable = ({
  refreshKey,
  handleFlashMessage,
  currentPage,
  currentPageLimit,
  onPageChange,
  onPageLimitChange
}) => {
  const navigate = useNavigate();
  const { billers, totalPages, loading, error, refetch } = useBillers(currentPage, currentPageLimit, refreshKey);
  const handleDelete = async (billerId) => {
    try {
      const response = await apiService.deleteBiller(billerId);
      handleFlashMessage(response.data.message);
      refetch();
    } catch (error) {
      console.error(error);
      const errorMessage = error.response?.data?.detail || "Error deleting biller";
      handleFlashMessage(errorMessage);
    }
  };

  const handleEdit = (billerId) => navigate(`/edit-biller/${billerId}`);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading billers.</div>;

  return (
    <TableWrapper>
      <h2>Billers List</h2>
      <Table>
        <thead>
          <tr>
            <TableHeader>Date Added</TableHeader>
            <TableHeader>Biller Name</TableHeader>
            <TableHeader>Biller Type</TableHeader>
            <TableHeader>Amount</TableHeader>
            <TableHeader>Amount Type</TableHeader>
            <TableHeader>Due Date</TableHeader>
            <TableHeader>Remarks</TableHeader>
            <TableHeader>Actions</TableHeader>
          </tr>
        </thead>
        <tbody>
          {billers.map((biller) => (
            <TableRow key={biller._id}>
              <TableData>{biller.date_added}</TableData>
              <TableData>{biller.biller_name}</TableData>
              <TableData>{biller.biller_type}</TableData>
              <TableData>{biller.amount}</TableData>
              <TableData>{biller.amount_type}</TableData>
              <TableData>{biller.usual_due_date_day}</TableData>
              <TableData>{biller.remarks}</TableData>
              <TableData>
                <EditButton onClick={() => handleEdit(biller._id)}>
                  <FaPenSquare />
                </EditButton>
                <DeleteButton onClick={() => handleDelete(biller._id)}>
                  <FaTrashAlt />
                </DeleteButton>
              </TableData>
            </TableRow>
          ))}
        </tbody>
      </Table>
      <PaginationControl
        currentPage={currentPage}
        currentPageLimit={currentPageLimit}
        totalPages={totalPages}
        handlePageChange={onPageChange}
        handlePageLimitChange={onPageLimitChange}
      />
    </TableWrapper>
  );
};

export default BillersTable;
